import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { AiListeningApiService } from 'src/services/aiListeningApi'
import { ReloadCooldownResponse } from 'src/services/__generated__/api'

interface UseReloadAiListeningCampaignMutationParams {
  onCooldown?: (nextReloadAvailableAt: string) => void
  onError?: () => void
  onSuccess?: () => void
}

export const useReloadAiListeningCampaignMutation = ({
  onCooldown,
  onError,
  onSuccess,
}: UseReloadAiListeningCampaignMutationParams = {}) => {
  return useMutation({
    mutationFn: (id: string) => AiListeningApiService.reload(id),
    onError: (error: AxiosError<ReloadCooldownResponse>) => {
      if (
        error.response?.status === 429 &&
        error.response?.data?.nextReloadAvailableAt
      ) {
        onCooldown?.(error.response.data.nextReloadAvailableAt)
        return
      }
      onError?.()
    },
    onSuccess: () => {
      onSuccess?.()
    },
  })
}
